export class UIDRefundPolicySceneController {
    hide() {
        this.refundPolicySceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.refundPolicySceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.refundPolicySceneContainerDiv = document.getElementById('scene_discord_refund_policy_container');
    }
}
